var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 532,
    height: 473,
    viewBox: "0 14 532 473",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M398.884 14.0176H132.961L0 250.416L132.961 486.774H398.884L531.845 250.416L398.884 14.0176ZM347.456 395.384H184.376L102.843 250.416L184.376 105.435H347.456L429.002 250.416L347.456 395.384Z",
    fill: "#EDECA5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_243_243",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 260,
    y: 0,
    width: 575,
    height: 511
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M690.539 0H403.635L260.174 255.065L403.635 510.13H690.539L834 255.065L690.539 0Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_243_243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.961 14.0176H398.884L531.845 250.416L398.884 486.774H132.961L0 250.416L132.961 14.0176Z",
    fill: "white",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigure);
export default __webpack_public_path__ + "static/media/figure.4947703c8cffd3b04f79285facb603ed.svg";
export { ForwardRef as ReactComponent };